/**
 * Operations hub tab definitions — single source for nav labels, paths, and active matching.
 */
export const OPERATIONS_BASE = '/portal/operations';

export const OPERATIONS_TABS = [
  { id: 'all', label: 'All', path: 'all', emoji: '📋' },
  { id: 'sops', label: 'SOPs', path: 'sops', emoji: '📖' },
  { id: 'kpis', label: 'KPIs', path: 'kpis', emoji: '📈' },
  { id: 'job-descriptions', label: 'Job Descriptions', path: 'job-descriptions', emoji: '💼' },
  { id: 'materials', label: 'Materials', path: 'materials', emoji: '📂' },
  { id: 'org-chart', label: 'Org Chart', path: 'org-chart', emoji: '🏢' },
  { id: 'goals', label: 'Goals', path: 'goals', emoji: '🎯', hiddenInNav: true },
];

/** Tabs shown in the Operations hub nav (hiddenInNav routes remain reachable by URL). */
export const OPERATIONS_NAV_TABS = OPERATIONS_TABS.filter((tab) => !tab.hiddenInNav);

export const DEFAULT_OPERATIONS_TAB = 'all';

/**
 * Resolve which tab is active from the current pathname.
 * @param {string} pathname - e.g. /portal/operations/sops
 */
export function getActiveOperationsTabId(pathname) {
  if (!pathname?.startsWith(OPERATIONS_BASE)) {
    return DEFAULT_OPERATIONS_TAB;
  }

  const remainder = pathname.slice(OPERATIONS_BASE.length).replace(/^\//, '');
  if (!remainder) {
    return DEFAULT_OPERATIONS_TAB;
  }

  const firstSegment = remainder.split('/')[0];

  for (const tab of OPERATIONS_TABS) {
    const paths = tab.matchPaths || [tab.path];
    if (paths.some((p) => firstSegment === p || remainder.startsWith(`${p}/`))) {
      return tab.id;
    }
  }

  return DEFAULT_OPERATIONS_TAB;
}

export function getOperationsTabHref(tab) {
  if (tab.path === '' || tab.id === 'all') {
    return `${OPERATIONS_BASE}/all`;
  }
  return `${OPERATIONS_BASE}/${tab.path}`;
}
